// API Configuration
export const API_ENDPOINTS = {
  find: 'https://api.polem-ia.com/retrieve',
  analyze: 'https://api.polem-ia.com/stream-analyze',
} as const;

// Sources for search
export const SOURCES = [
  'polemia', 'polemia-archives', 'ojim', 'tv-libertes',
  'iliade', 'iliade-citations', 'metapo-infos', 'elements',
  'contribuables', 'oid', 'odj', 'vanguard', 'ipj',
  'liberte-politique', 'ifrap'
] as const;

// Example prompts for the hero section
export const EXAMPLE_PROMPTS = [
  "Soros et le financement des associations de gauche",
  "Chiffres de la criminalité des Algériens en France et en Europe",
  "Quels sont les ressorts idéologiques du progressisme contemporain ?",
  "Culture ou civilisation : quelle différence fondamentale ?",
  "La notion d'identité européenne a-t-elle un sens ?",
  "Peut-on parler d'un effacement du sacré ?",
  "Le rôle des médias dans la polarisation politique ?",
  "Peut-on encore parler de bien commun ?",
  "Le progrès est-il un mythe moderne ?",
  "Faut-il augmenter les impôts ?",
  "L'écologie est-elle de droite ?",
  "Les médias sont-ils de gauche ?",
  "Qu'est-ce que la postmodernité ?",
  "Qu'appelle-t-on marxisme culturel ?",
  "Information ou communication : où est la frontière ?",
  "Peut-on parler de fabrication de l'opinion publique ?",
  "Europe et Occident : y a-t-il une différence ?",
  "Quel est la situation du niveau scolaire en France ?",
  "Classement PISA de la France ?",
  "Le gouvernement des juges c'est quoi ?",
  "Peux-tu définir l'anarcho-tyrannie ?",
  "Qu'est-ce que la dette ?",
  "France : plus de 3000 milliards de dette. Que faire ?",
  "Que penser de France Télévisions ?",
  "À quoi sert l'ARCOM ?",
] as const;

// Utility functions
export function shuffleArray<T>(array: readonly T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
